import Plugin from '../Plugin'

export default class Coins extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'coins_update': this.coinsUpdate
        }
    }

    coinsUpdate(args = {}) {
        if (!this.world || !this.world.client) {
            return
        }

        const previous = Number.isFinite(this.world.client.coins) ? this.world.client.coins : 0
        const nextCoins = Number.isFinite(args.coins) ? args.coins : previous
        const delta = Number.isFinite(args.delta) ? args.delta : nextCoins - previous

        this.world.client.coins = nextCoins

        this.interface.refreshPlayerCard()
        this.interface.updateCatalogCoins(nextCoins)

        if (args.showPrompt && delta !== 0) {
            // Show prompt (z-index management in PromptController handles overlay visibility)
            this.interface.prompt.showCoin(delta)
        }
    }

}
